import React, { useState, useRef } from "react";
import styled from "styled-components";
import { deviceSize } from "../responsive";
import { data } from "./data";

const BlogContainer = styled.div`
  width: 100%;
  margin-top: 90px;
`;

//trbl
const BlogTopBorder = styled.div`
  border-top: 1px solid #000;
  width: 100%;
  padding-bottom: 5%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const BlogContentWrapper = styled.div`
	display: flex;
	justify-content: space-between;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    margin: 10%;

  }

`;

const BlogWrapper = styled.div`
  display: grid;
  padding-top: 5%;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-items: center;
  padding-left: 5%;
  width: 65%;


  @media screen and (max-width: 768px) {
    order: 1;
    grid-template-columns: 1fr;
    margin: 0 0;
    width: 100%;
    grid-gap: 40px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-left: 5%;
    padding-right: 5%;
  }
`;

const BlogCard = styled.div`
  display: flex;
  align-content: center;
  flex-direction: column;
  height: 500px;
  width: 90%;


  @media screen and (max-width: 768px) {
    width: 100%;
    height: auto;
  }

`;

const Blogheader = styled.h2`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 800;
  font-size: 1.5em;
  line-height: 39px;
  width: 100%;
  line-height: 144px;
  height: 144px;
  color: white;
  background-color: #b55959;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 20px;
    width: 100%;
    margin: 50px 0 80px 0;
    height: 100px;
    line-height: 5;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
  }
`;


const Img = styled.img`
  width: 100%;
  padding-right: 0;
  filter: drop-shadow(6px 6px 10px rgba(0, 0, 0, 0.25));
  border-radius: 10px;

  @media screen and (max-width: ${deviceSize.laptop}px) {
    width: 89%;
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    height: 190px;
  }
`;

const BlogTopLinetext = styled.h3`
  margin-top: 5%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1em;
  line-height: 25px;
  color: #000000;
  text-align: left;
  overflow: none;

  @media screen and (max-width: ${deviceSize.laptop}px) {
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 10%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-left: 0;
    width: 90%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    font-size: 0.9em;
    margin-left: 0px;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
  }
`;

const BlogBottomlineText = styled.h4`
  margin-top: 5px;
  font-family: "Roboto";
  font-weight: 500;
  font-size: 0.9em;
  line-height: 25px;
  color: #727272;
  text-align: left;

  @media screen and (max-width: ${deviceSize.laptop}px) {
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 10%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-left: 2%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    font-size: 0.7em;
    margin-left: 0px;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
  }
`;

const SubText = styled.p`
  text-align: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 1em;
  line-height: 25px;
  margin-top: 0px;
  color: #585858;

  @media screen and (max-width: ${deviceSize.laptop}px) {
  }

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 10%;
  }

  @media screen and (max-width: ${deviceSize.tablet}px) {
    margin-left: 2%;
    width: 100%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    font-size: 0.8em;
    margin-left: 0px;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    margin-left: 0px;
  }
`;

const BlogLink = styled.a`
  display: flex;
  justify-content: flex-start;
  text-decoration: none;
  color: inherit;
  width: 100%;
  height: auto;
  padding-bottom: 25%;

  @media screen and (max-width:768px) {
    padding-bottom: 5%;
    height: auto;
  }

`;

const RecentPostsContainer = styled.div`
  padding-top: 5%;
	width: 25%;
  height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 5%;

  @media screen and (max-width: 768px) {
    order: 3;
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 5%;
  }
`;

const RecentPostsHeader = styled.h3`
	background-color: #EEEEEE;
	color: #000;
	border-radius: 20px;
	width: 80%;
	height: 3%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const RecentPostItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
  justify-content: center;
	width: 100%;
	height: 10%;

`;

const RecentPostTitle = styled.h4`
	color: #727272;
`;

const RecentPostSubtitle = styled.h4`
  color: #727272;
  margin-top: 0%;
`

const SeparatorLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: #ccc;
`;

const PaginationDiv = styled.div`
  margin-top: 5%;
  margin-bottom: 5%;
  width: 100%;

  @media screen and (max-width: 768px) {
    order: 1;
  }
`;

const PaginationSpan = styled.span`
  margin: 0 5px;
  padding: 8px 12px;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? "#B55959" : "white")};
  color: ${({ isActive }) => (isActive ? "white" : "#B55959")};

  @media screen and (max-width: 768px) {
    order: 2;
    margin-top: 10px; /* Adjust margin as needed */
  }
`;


export function Blog(props) {
//   const isMobile = useMediaQuery({ maxWidth: deviceSize.mobile });
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);
  const blogSectionRef = useRef(null);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);

    if (pageNumber >= 1 && pageNumber <= 3 && blogSectionRef.current) {
        // Get the top position of the BlogSectionContainer
        const topPosition = blogSectionRef.current.offsetTop;

        // Scroll to the top of the BlogSectionContainer div
        window.scrollTo({
            top: topPosition - 100,
            behavior: 'smooth' // Optional: Smooth scrolling animation
        });
    }
}

  return (
    <BlogContainer ref={blogSectionRef} id="blog-container">
      <Blogheader>The Expedient Recruiting Blog </Blogheader>
	  <BlogContentWrapper>
		<BlogWrapper id="blog-wrapper">
			{currentPosts.map((post) => (
			<BlogLink key={post.id} href={`${post.link}`}>
				<BlogCard>
				<Img src={post.img} alt={post.title} />
				<BlogTopLinetext>{post.title}</BlogTopLinetext>
				{post.subtitle && (
          <BlogBottomlineText>{post.subtitle}</BlogBottomlineText>
          )}
        <BlogTopBorder id="seperator"/>
				<SubText>{post.subtext}</SubText>
				</BlogCard>
			</BlogLink>
			))}
		</BlogWrapper>
		<RecentPostsContainer>
			<RecentPostsHeader>RECENT POSTS</RecentPostsHeader>
			{currentPosts.map((post) => (
				<RecentPostItem key={post.id}>
					<a href={`/${post.link}`} style={{textDecoration: "none", height: "90%", display: "flex", flexDirection: "column", alignItems: "center"}}>
						<RecentPostTitle>{post.title}</RecentPostTitle>
            {post.subtitle && <RecentPostSubtitle>{post.subtitle}</RecentPostSubtitle>}
					</a>
					<SeparatorLine />
				</RecentPostItem>
			))}
		</RecentPostsContainer>
	  </BlogContentWrapper>
      <PaginationDiv>
        {Array.from(
          { length: Math.ceil(data.length / postsPerPage) },
          (_, index) => (
            <PaginationSpan
              key={index + 1}
              isActive={currentPage === index + 1}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </PaginationSpan>
          )
        )}
      </PaginationDiv>
    </BlogContainer>
  );
}
